import { FC } from "react";

import { Input, Pagination, Select, Space, Table, Tag } from "antd";

import styles from "./Examinations.module.scss";

import useExaminations from "@/hooks/useExaminations";
import { orderByOptions } from "@/root/consts";
import { IExamination } from "@/models/Examination";
import { format } from "date-fns";
import convertMsToTime from "@/utils/convertMsToTime";

const { Option } = Select;

const columns = [
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (status: string) => {
      if (status === "new") {
        return <Tag color="green">new</Tag>;
      }
      return <Tag color="red">finished</Tag>;
    },
  },
  { title: "Exam mode", dataIndex: "examMode", key: "examMode" },
  {
    title: "Name of the manufacturer of the test sample",
    dataIndex: "sampleManufacturerName",
    key: "sampleManufacturerName",
  },
  {
    title: "Test sample's type",
    dataIndex: "sampleType",
    key: "sampleType",
  },
  {
    title: "Test sample's name",
    dataIndex: "sampleName",
    key: "sampleName",
  },
  {
    title: "Manufactured date",
    dataIndex: "sampleManufacturedDate",
    key: "sampleManufacturedDate",
    render: (date: string) => (
      <span>{format(new Date(date), "yyyy-MM-dd")}</span>
    ),
  },
  {
    title: "Serial number",
    dataIndex: "sampleSerialNumber",
    key: "sampleSerialNumber",
  },
  { title: "Operator", dataIndex: "operator", key: "operator" },
  { title: "Notes", dataIndex: "notes", key: "notes" },
  {
    title: "Started at",
    dataIndex: "startDate",
    key: "startDate",
    render: (date: string) => {
      if (date) {
        return <span>{format(new Date(date), "yyyy-MM-dd HH:mm:ss")}</span>;
      }
    },
  },
  {
    title: "Finished at",
    dataIndex: "finishDate",
    key: "finishDate",
    render: (date: string) => {
      if (date) {
        return <span>{format(new Date(date), "yyyy-MM-dd HH:mm:ss")}</span>;
      }
    },
  },
  {
    title: "Duration",
    dataIndex: "finishDate",
    key: "finishDate",
    render: (_: any, exam: IExamination) => {
      if (exam.startDate && exam.finishDate) {
        const start = new Date(exam.startDate.replace(/\.\d+/, "")).getTime();
        const finish = new Date(exam.finishDate.replace(/\.\d+/, "")).getTime();
        const duration = convertMsToTime(new Date(finish - start).getTime());
        return <span>{duration}</span>;
      }
    },
  },
];

interface ExaminationsProps {
  onChoose: (examination: IExamination) => void;
}

const Examinations: FC<ExaminationsProps> = ({ onChoose }) => {
  const {
    pages,
    examinations,
    order,
    currentPage,
    status,
    loading,
    setPage,
    setOrder,
    setDate,
    setStatus,
    handleSearch,
  } = useExaminations();

  const preparedExaminations = examinations.map((examination) => ({
    ...examination,
    key: examination.examId,
  }));

  const handleRow = (scheduleItem: IExamination) => ({
    onClick: () => onChoose(scheduleItem),
  });

  return (
    <div>
      <Space className={styles.filters}>
        <Input placeholder="Search" onChange={handleSearch} />
        {/*<DatePicker onChange={(date) => date && setDate(date)} />*/}
        <Select value={order} onSelect={setOrder}>
          {orderByOptions.map((by) => (
            <Option key={by.value} value={by.value}>
              {by.title}
            </Option>
          ))}
        </Select>
        <Select placeholder="status" value={status} onSelect={setStatus}>
          <Option value="new">new</Option>
          <Option value="finished">finished</Option>
        </Select>
      </Space>
      <Table
        className={styles.table}
        size="small"
        pagination={false}
        loading={loading}
        columns={columns}
        scroll={{ x: true }}
        dataSource={preparedExaminations}
        onRow={handleRow}
      />
      {pages > 1 && (
        <Pagination
          data-testid="examinations-pagination"
          className={styles.pagination}
          pageSize={1}
          total={pages}
          current={currentPage}
          onChange={setPage}
        />
      )}
    </div>
  );
};

export default Examinations;
